module.exports = {"dados":[{"id":1,"icon":"car","description":"Você pode adicionar mais de um veículo no seu plano e compartilhar o saldo entre eles."},{"id":2,"icon":"tagVeloe","description":"Seu saldo será usado para pagar suas passagens em pedágios, estacionamentos, abastecimento e a também mensalidade do seu plano, descontada na data de aniversário da sua adesão."},{"id":3,"icon":"hand","description":"Baixe o nosso app e conheça nossos outros serviços."}]}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/PlanData/data.json
// module id = 2062
// module chunks = 0